import dynamic from 'next/dynamic';
import { GetServerSideProps } from 'next';

import endpointConstructor from 'utils/shared/endpointConstructor';
import fetcher from 'utils/shared/fetcher';
import parallel from 'utils/shared/parallel';

import type { HashtagsProps } from 'types/hashtags';

export const getServerSideProps: GetServerSideProps<HashtagsProps> = async ({ res, req }) => {
  const getServerSideCookie = (await import('utils/shared/getCookie')).default;
  const deviceid = getServerSideCookie(req.headers.cookie, 'paa-did');

  const TOP_TAGS = endpointConstructor('hashtag', 'topHashtags', {});
  const VIRAL_TAGS = endpointConstructor('hashtag', 'viralHashtags', {});

  const [topTags, viralTags] = await parallel(
    [fetcher(TOP_TAGS, { headers: { deviceid } }), fetcher(VIRAL_TAGS, { headers: { deviceid } })],
    {
      res,
      fallback: [[], []],
    },
  );

  return {
    props: {
      topTags,
      viralTags,
    },
  };
};

const Hashtags = dynamic(() => import('templates/Hashtags'));

export default Hashtags;
